import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import ErrorMessage from "../components/error-message/error-message.component";
import LoginPage from "../pages/login-page/login-container.component";
import ProtectedRoutes from "./protected.routes";
import MainPage from "../pages/main-page/main-page.component";

const protectedRoutes = [
    {
        path: "/",
        component: MainPage,
    },
];

function MainRoute() {
    return (
        <div className="main-route">
            <Switch>
                {protectedRoutes.map(({ component, path }) => (
                    <ProtectedRoutes
                        path={path}
                        key={path}
                        component={component}
                    />
                ))}
                <Route path="/login" exact component={LoginPage} />
                <Route
                    path="/403"
                    exact
                    render={() => (
                        <ErrorMessage
                            message="403: Forbidden! please contact your administrator"
                            size={2}
                        />
                    )}
                />
                <Redirect to="/login" />
                <Route
                    path="*"
                    exact
                    render={() => (
                        <ErrorMessage
                            message="404: Page you requested not found"
                            size={2}
                        />
                    )}
                />
            </Switch>
        </div>
    );
}

export default MainRoute;
